module.exports = __webpack_public_path__ + "img/circulateOrange.b7b274dd.png";